import { Injectable, inject } from '@angular/core';
import { firstValueFrom, timeout } from 'rxjs';
import { ApiService } from './api.service';

export function subscriptionError(error: any): string {
  const message = error?.error?.error ?? error?.message;
  return typeof message === 'string' ? message : '処理に失敗しました。時間をおいて再度お試しください。';
}

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  private api = inject(ApiService);

  getByStudio(id: number | string, includeEnded = false): Promise<any[]> {
    return this.api.get(`/studio/${id}/subscription?includeEnded=${includeEnded}`);
  }

  getByMember(id: number | string, includeEnded = false): Promise<any[]> {
    return this.readMemberList(`/member/${id}/subscription?includeEnded=${includeEnded}`);
  }

  getRequests(id: number | string): Promise<any[]> {
    return this.readMemberList(`/member/${id}/notification`);
  }

  private async readMemberList(path: string): Promise<any[]> {
    const response = await firstValueFrom(this.api.getRaw<any>(path).pipe(timeout(15000)));
    if (response?.success !== true || !Array.isArray(response.result)) {
      throw new Error(response?.error || '一覧を取得できませんでした。');
    }
    return response.result;
  }

  start(id: number, body: { productId: number; startDate: string; deliveryDay: number | null }) {
    return this.update(id, 'start', body);
  }

  stop(id: number, body: { subscriptionId: number; endDate: string }) {
    return this.update(id, 'stop', body);
  }

  updateDeliveryDay(id: number, body: { subscriptionId: number; deliveryDay: number | null }) {
    return this.update(id, 'delivery_day', body);
  }

  private async update(id: number, action: string, body: any): Promise<any> {
    const response = await firstValueFrom(this.api.postRaw(`/member/${id}/subscription/${action}`, body));
    if (response?.success !== true) throw new Error(response?.error || '物販定期便を更新できませんでした。');
    return response.result;
  }
}
